<template>
    <b-navbar variant="light">
        <b-navbar-nav class="ml-auto">
            <b-nav-item href="#" @click="prevMonth">
                {{ trans.labels['btn.prev-month'] }}
                <font-awesome-icon class="fa-fw" icon="chevron-left" />
            </b-nav-item>
        </b-navbar-nav>

        <b-nav-form>
            <b-input-group class="" size="sm">
                <b-form-select ref="month" v-model="value" :options="optionsMonth()" @change="input"></b-form-select>
            </b-input-group>
        </b-nav-form>

        <b-navbar-nav class="mr-auto">
            <b-nav-item href="#" @click="nextMonth">
                <font-awesome-icon class="fa-fw" icon="chevron-right" />
                {{ trans.labels['btn.next-month'] }}
            </b-nav-item>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {    
    props: [
        'value'
    ],
    emits: [
        'next',
        'prev',
    ],
    computed: {
        ...mapGetters([
            'trans',
        ]),
    },
    data () {
        return {
        }
    },
    methods: {
        async input(value) {
            this.$emit('input', value)
        },
        async prevMonth(value) {
            let index = this.$refs.month.options.findIndex(v => v.value === this.value)
            index--
            if (index < 0) {
                return
            }
            this.$emit('input', this.$refs.month.options[index].value)
        },
        async nextMonth(value) {
            let index = this.$refs.month.options.findIndex(v => v.value === this.value)
            index++
            if (this.$refs.month.options.length <= index) {
                return
            }
            this.$emit('input', this.$refs.month.options[index].value)
        },
        optionsMonth() {
            let years = [...Array(10).keys()].map((v) => { return v + 2022 + '' })
            let monthes = [...Array(12).keys()].map((v) => { return (v + 1 + '').padStart(2, '0') })
            let options = []
            for (let i = 0; i < years.length; i++) {
                for (let j = 0; j < monthes.length; j++) {
                    options.push({
                        value: years[i] + monthes[j],
                        text: years[i] + '/' + monthes[j],
                    })
                }
            }
            return options
        },
    },
    components: {
    }
}
</script>
